import React from 'react';

const DecorativeImage = ({ src, alt, className = '' }) => (
  <div className={`relative flex items-center justify-center ${className}`}>
    {/* Top star - Terracotta */}
    <svg className="absolute -top-4 left-1/2 -translate-x-1/2 w-20 h-20 z-10" viewBox="0 0 100 100" fill="#C85A40">
      <path d="M50 0 C55 35, 65 45, 100 50 C65 55, 55 65, 50 100 C45 65, 35 55, 0 50 C35 45, 45 35, 50 0Z" />
    </svg>
    {/* Bottom-left star - Forest Green */}
    <svg className="absolute -bottom-3 -left-3 w-16 h-16 z-10" viewBox="0 0 100 100" fill="#1A3628">
      <path d="M50 0 C55 35, 65 45, 100 50 C65 55, 55 65, 50 100 C45 65, 35 55, 0 50 C35 45, 45 35, 50 0Z" />
    </svg>
    {/* Bottom-right star - Stone */}
    <svg className="absolute -bottom-2 -right-2 w-12 h-12 z-10" viewBox="0 0 100 100" fill="#EAE7DF">
      <path d="M50 0 C55 35, 65 45, 100 50 C65 55, 55 65, 50 100 C45 65, 35 55, 0 50 C35 45, 45 35, 50 0Z" />
    </svg>
    {/* Small accent dot */}
    <div className="absolute bottom-[40%] left-[5%] w-3 h-3 rounded-full bg-[#C85A40] z-10" />
    {/* Circular image */}
    <div className="w-[300px] h-[300px] md:w-[400px] md:h-[400px] lg:w-[440px] lg:h-[440px] rounded-full overflow-hidden border-4 border-white shadow-xl">
      <img src={src} alt={alt} className="w-full h-full object-cover" />
    </div>
  </div>
);

export default DecorativeImage;
